import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Button, CollapseCard } from '@totalsoft/rocket-ui';
import FacilityKpiIndicatorsComponent from './FacilityKpiIndicatorsComponent';
import Assignment from '@mui/icons-material/Assignment';
import { Prompt } from 'react-router-dom';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const FacilityKpiIndicatorsListContainer = ({
  kpiIndicators,
  handleSave,
  handleChange,
  isSaving,
  isDirty,
  loading,
  isFromOffer,
  isFromFolder,
  isFromFacility,
  hasFacilityOffer,
  expanded,
  toggleExpanded
}) => {
  const { t } = useTranslation();

  const items = kpiIndicators.map(
    ({ itemTypeId, itemTypeName, indicatorId, indicatorValue, indicatorName, indicatorPropertyTypeCode }, index) => (
      <FacilityKpiIndicatorsComponent
        index={index}
        key={itemTypeId}
        itemTypeId={itemTypeId}
        itemTypeName={itemTypeName}
        indicatorId={indicatorId}
        indicatorValue={indicatorValue}
        indicatorName={indicatorName}
        indicatorPropertyTypeCode={indicatorPropertyTypeCode}
        handleChange={handleChange}
        isSaving={isSaving}
        disabled={isFromFolder || (isFromFacility && hasFacilityOffer)}
      />
    )
  );

  const content = loading ? (
    <WrappedFakeText lines={6} />
  ) : (
    <>
      {isFromFacility && !hasFacilityOffer && <Prompt when={isDirty} message={t('LeavingWithoutSaving')} />}
      {!isFromOffer ? (
        <Grid container spacing={2}>
          {items}
        </Grid>
      ) : (
        <>{items}</>
      )}
      {isFromFacility && !hasFacilityOffer && (
        <GridActionsWrapper item xs={12}>
          <Button color='primary' variant='contained' onClick={handleSave} disabled={!isDirty || isSaving}>
            {isSaving ? t('Saving') + '...' : t('Save')}
          </Button>
        </GridActionsWrapper>
      )}
    </>
  );

  return isFromOffer ? (
    content
  ) : (
    <CollapseCard
      icon={Assignment}
      iconColor='primary'
      title={t('Facility.KpiIndicators.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      showFooter={false}
      toggleOnHeaderClick
    >
      {content}
    </CollapseCard>
  );
};

FacilityKpiIndicatorsListContainer.propTypes = {
  kpiIndicators: PropTypes.array.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isFromOffer: PropTypes.bool,
  isFromFolder: PropTypes.bool,
  isFromFacility: PropTypes.bool,
  hasFacilityOffer: PropTypes.bool,
  expanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired
};

export default FacilityKpiIndicatorsListContainer;
